module.exports = __webpack_public_path__ + "img/logo9.f055cbfb.png";